import React from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardImg } from 'reactstrap';
import './Feature.css';


const Feature = (props) => {
	const { title, question, summary, backgroundImage, image, overlayColor } = props;

	return (
		<div className="feature" style={{ background: `url(${backgroundImage})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
			<div className="overlay" style={{ backgroundColor: overlayColor }}>
			</div>
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-lg-6">
					<div className="feature-text">
						<h5>{title}</h5>
						<h2>{question}</h2>
						<h6>{summary}</h6>
					</div>
				</div>
				<div className="col-xs-12 col-sm-12 col-lg-6">
					<div className="feature-screenshot">
						<img src={image} alt="" />
					</div>	
				</div>
			</div>
		</div>
	);
};

export { Feature };



/** WEBPACK FOOTER **
 ** ./src/common/Feature.js
 **/